export const UserCounters = (json: IUserCounters): IUserCountersModel => {
	const fromJSON = (json: IUserCounters) => {
		const { active_carts_items_count, active_negotiations_items_count, active_orders_price, unread_notifications_count, ...rest } = json
		return {
			...rest,
			activeCartsItemsCount: active_carts_items_count,
			activeNegotiationsItemsCount: active_negotiations_items_count,
			activeOrdersPrice: active_orders_price,
			unreadNotificationsCount: unread_notifications_count,
		}
	}

	return { ...fromJSON(json) }
}

export const userCountersToJSON = (obj: Partial<IUserCountersModel>): Partial<IUserCounters> => {
	const { activeCartsItemsCount, activeNegotiationsItemsCount, activeOrdersPrice, unreadNotificationsCount, ...rest } = obj
	return {
		active_carts_items_count: activeCartsItemsCount,
		active_negotiations_items_count: activeNegotiationsItemsCount,
		active_orders_price: activeOrdersPrice,
		unread_notifications_count: unreadNotificationsCount,
		...rest,
	}
}

export const UserAdminCounters = (json: IUserAdminCounters): IUserAdminCountersModel => {
	const fromJSON = (json: IUserAdminCounters) => {
		const { to_approve, ...rest } = json
		return {
			...rest,
			toApprove: to_approve,
		}
	}

	return { ...fromJSON(json) }
}
